/**
 * Onde está o foco do teclado.
 *
 * A mesma tecla significa coisas diferentes conforme o cursor esteja no mundo ou num
 * campo de texto: `W` é um passo para o norte e é também a primeira letra de "vamos". Quem
 * decide é o foco, e a decisão precisa ser **uma só** — a barra de magias já fazia a
 * checagem e o controlador de direção não, e o resultado foi um chat em que quase nenhuma
 * palavra do português chegava inteira (PRD §11.1, item 2).
 *
 * A checagem olha o alvo do evento **e** o elemento ativo do documento. Os dois porque
 * eles podem discordar: um `keydown` capturado na janela por um plugin de terceiros chega
 * com `target` no `body` mesmo com o campo focado, e nesse caso só o `activeElement` diz
 * a verdade.
 */
export function isTyping(target?: EventTarget | null): boolean {
  return isTextField(target) || isTextField(document.activeElement);
}

function isTextField(node: EventTarget | null | undefined): boolean {
  return (
    node instanceof HTMLInputElement ||
    node instanceof HTMLTextAreaElement ||
    (node instanceof HTMLElement && node.isContentEditable)
  );
}
